<template>
  <div class='question_back_button_container'>
    <MDBBtn @click="onHandleBack()" aria-label="Go back to the previous page" class='button'>
      Back
    </MDBBtn>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import { MDBBtn } from "mdb-vue-ui-kit";

export default {
  components: {
    MDBBtn
  },
  computed: {
    ...mapGetters([
      'activeItem',
    ]),
  },
  methods: {
    ...mapMutations([
      'goToPreviousPage',
      'resetScene',
    ]),
    ...mapActions([
      'resetLastItem',
    ]),
    onHandleBack() {
      if (this.activeItem.name) {
        // undo current selection
        this.resetLastItem();
      } else {
        this.goToPreviousPage();
      }
    },
  }
}
</script>
